export default "__VITE_ASSET__77374cf9__"